import { createFileRoute } from "@tanstack/react-router";

import { RequireAuth } from "../features/auth/RequireAuth";
import { LandingRedirect } from "../features/landing/LandingRedirect";

/**
 * `/` is not a page. It is where every sign-in without a destination of its
 * own ends up: the gate below for a Google or email-link sign-in started here,
 * and /sign-in when its `redirect` is absent. Signed out, the gate renders the
 * sign-in screen in place, so an emailed link returns here too. Signed in, the
 * person is sent to All Events if they are in no event yet, else to My Events
 * (see landing.ts).
 */
export const Route = createFileRoute("/")({
  component: () => (
    <RequireAuth>{(user) => <LandingRedirect uid={user.uid} />}</RequireAuth>
  ),
});
